import type { Prettify } from "../../utils/typeUtils";

export class AIUseCaseSummary {
    
    useCaseTitle: string = "";
    useCaseSummary: string = "";
    useCaseOwner: string = "";
    department: string = "";
    adoptionStage: string = "";
    
    constructor(init?: Partial<AIUseCaseSummary>) {
      Object.assign(this, init);
    }
}

export class BusinessContext{
    businessCriticality: string = "";
    applicableSectors: string = "";
    deploymentRegions: string = "";
    impactedNationalities: string = "";
    humanInTheLoop: string = "";
    maintenanceApproach: string = "";

    constructor(init?: Partial<BusinessContext>) {
        Object.assign(this, init);
    }
}

export class IntendedUse{
    intendedUsers: string = "";
    useCaseScenarios: string = "";
    accessibleBy: string = "";
    systemFeatures: string = "";

    constructor(init?: Partial<IntendedUse>) {
        Object.assign(this, init);
    }
}

export class DataContext{
    dataContentDescription: string = "";
    dataFormats: string = "";
    dataSources: string = "";
    dataSensitivity: string = "";
    personalData: string = "";
    dataOwnership: string = "";
    dataResidency: string = "";

    constructor(init?: Partial<DataContext>) {
        Object.assign(this, init);
    }
}

export class UseCaseDataContext {
    training: DataContext = new DataContext();
    input: DataContext = new DataContext();
    output: DataContext = new DataContext();
    constructor(init?: Partial<UseCaseDataContext>) {
        Object.assign(this, init);
    }
}

export type DataContextId = Prettify<keyof UseCaseDataContext>;

export class AISystemContext {
    aiCapabilities: string = "";
    aiModels: string = "";
    softwareComponents: string = "";
    deploymentEnvironment: string = "";
    constructor(init?: Partial<AISystemContext>) {
        Object.assign(this, init);
    }
}

export class UseCase {
    id: string = "";

    useCaseSummary: AIUseCaseSummary = new AIUseCaseSummary();
    intendedUse: IntendedUse = new IntendedUse();
    businessContext: BusinessContext = new BusinessContext();
    dataContext: UseCaseDataContext = new UseCaseDataContext();
    systemComponents: AISystemContext = new AISystemContext();

    constructor(init?: Partial<UseCase>){
        Object.assign(this, init); 
    }

}


